// extracted by mini-css-extract-plugin
export default {"inputLabel":"selectinput_inputLabel__+MOgC"};